/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getAccountDetail = /* GraphQL */ `
  query GetAccountDetail($user_id: String!) {
    getAccountDetail(user_id: $user_id) {
      user_id
      bank_code
      bank_name
      branch_code
      branch_name
      account_category
      account_num
      account_person_name
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listAccountDetails = /* GraphQL */ `
  query ListAccountDetails(
    $user_id: String
    $filter: ModelAccountDetailFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listAccountDetails(
      user_id: $user_id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        user_id
        bank_code
        bank_name
        branch_code
        branch_name
        account_category
        account_num
        account_person_name
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getInvitee = /* GraphQL */ `
  query GetInvitee($user_id: String!, $invitee_id: String!) {
    getInvitee(user_id: $user_id, invitee_id: $invitee_id) {
      user_id
      invitee_id
      invitee_conversion_date
      reward_id
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listInvitees = /* GraphQL */ `
  query ListInvitees(
    $user_id: String
    $invitee_id: ModelStringKeyConditionInput
    $filter: ModelInviteeFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listInvitees(
      user_id: $user_id
      invitee_id: $invitee_id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        user_id
        invitee_id
        invitee_conversion_date
        reward_id
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTransfer = /* GraphQL */ `
  query GetTransfer($id: ID!) {
    getTransfer(id: $id) {
      status
      memo
      has_failed
      transferred_at
      subtotal
      fee
      tax
      total
      planned_month
      planned_name
      planned_period
      id
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listTransfers = /* GraphQL */ `
  query ListTransfers(
    $filter: ModelTransferFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTransfers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        status
        memo
        has_failed
        transferred_at
        subtotal
        fee
        tax
        total
        planned_month
        planned_name
        planned_period
        id
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getRewardCategory = /* GraphQL */ `
  query GetRewardCategory($id: ID!) {
    getRewardCategory(id: $id) {
      name
      type
      amount
      is_active
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listRewardCategories = /* GraphQL */ `
  query ListRewardCategories(
    $filter: ModelRewardCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRewardCategories(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        name
        type
        amount
        is_active
        id
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getReward = /* GraphQL */ `
  query GetReward($id: ID!) {
    getReward(id: $id) {
      user_id
      amount
      reward_category_id
      transfer_id
      owner
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listRewards = /* GraphQL */ `
  query ListRewards(
    $filter: ModelRewardFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRewards(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        user_id
        amount
        reward_category_id
        transfer_id
        owner
        id
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getContact = /* GraphQL */ `
  query GetContact($id: ID!, $phone_number: String!, $email: String!) {
    getContact(id: $id, phone_number: $phone_number, email: $email) {
      id
      name
      phone_number
      email
      contents
      is_active
      memo
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listContacts = /* GraphQL */ `
  query ListContacts(
    $id: ID
    $phone_numberEmail: ModelcontactPrimaryCompositeKeyConditionInput
    $filter: ModelContactFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listContacts(
      id: $id
      phone_numberEmail: $phone_numberEmail
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
        phone_number
        email
        contents
        is_active
        memo
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
